import React from 'react'

import {
    CardGridEntradaDados,
    CardGridDividerElementos,
    CardGridDivBodyEntradaDados,
} from '../../../business-components/Card/Card'

import {
    GridContainer,
    GridItem2,
    GridItem4,
    GridItem4xs6,
    GridItem6,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    CardGridDivHeaderEntradaDadosConjuge,
    NomeConjuge,
    NascimentoConjuge,
    IdadeConjuge,
    SexoConjuge,
    NomeCurtoConjuge,
    CpfConjuge,
    ContatoConjuge,
    ContaInvestimentosConjuge,
    AvatarConjuge,
} from '../cadastro-form/CadastroCompConjuge'



const FormFormConjuge = ({ values, handleChange, setFieldValue, linhaTipoLicenca, linhaFormList, jsonIntegracao }) => {

    return (
        <GridContainer>
            <GridItem12>
                <CardGridEntradaDados>
                    <CardGridDivHeaderEntradaDadosConjuge
                        values={values}
                    />

                    <CardGridDivBodyEntradaDados>
                        <GridContainer>
                            <GridItem12>
                                <NomeConjuge
                                    values={values}
                                    handleChange={handleChange}
                                />
                            </GridItem12>
                        </GridContainer>

                        <GridContainer>
                            <GridItem4xs6>
                                <NascimentoConjuge
                                    values={values}
                                    setFieldValue={setFieldValue}
                                />
                            </GridItem4xs6>

                            <GridItem2>
                                <IdadeConjuge
                                    values={values}
                                    handleChange={handleChange}
                                />
                            </GridItem2>

                            <GridItem4>
                                <SexoConjuge
                                    values={values}
                                    handleChange={handleChange}
                                />
                            </GridItem4>
                        </GridContainer>

                        {(!jsonIntegracao || !jsonIntegracao.integracaoInclusaoSiteInstitucional2) && (
                            <>
                                {(linhaFormList.informaNomeCurto === "S" || linhaFormList.informaCpf === "S") && (
                                    <>
                                        <CardGridDividerElementos/>
                                        
                                        <GridContainer>
                                            {linhaFormList.informaNomeCurto === "S" && (
                                                <GridItem6>
                                                    <NomeCurtoConjuge
                                                        values={values}
                                                        handleChange={handleChange}
                                                    />
                                                </GridItem6>
                                            )}
                                            
                                            {linhaFormList.informaCpf === "S" && (
                                                <GridItem6> 
                                                    <CpfConjuge
                                                        values={values}
                                                        handleChange={handleChange}
                                                    />
                                                </GridItem6>
                                            )}
                                        </GridContainer>
                                    </>
                                )}
                                
                                {linhaFormList.informaContatos === "S" && (
                                    <>
                                        <CardGridDividerElementos/>

                                        <ContatoConjuge
                                            values={values}
                                            handleChange={handleChange}
                                        />
                                    </>
                                )}

                                {linhaFormList.informaContasInvestimentos === "S" &&
                                linhaTipoLicenca.exibirSomentePrevidenciaPrivada === 'N' && (
                                    <>
                                        <CardGridDividerElementos/>

                                        <ContaInvestimentosConjuge
                                            values={values}
                                            handleChange={handleChange}
                                        />
                                    </>
                                )}
                            </>
                        )}
                        
                        <CardGridDividerElementos/>

                        <AvatarConjuge
                            values={values}
                            setFieldValue={setFieldValue}
                        />                               
                    </CardGridDivBodyEntradaDados>
                </CardGridEntradaDados>
            </GridItem12>
        </GridContainer>
    )
}

export default FormFormConjuge